<template>
  <Loading v-if="!hasLoadedData || !listSession" />
  <div v-else id="printMe">
    <vx-card class="mb-5">
      <div class="vx-row mb-6 mt-2">
        <div class="vx-col w-full">
          <vs-row vs-justify="space-between" vs-w="12">
            <h2 style="font-size: revert; font-weight: 500">
              {{ listSession.list.title }}
            </h2>
            <vs-button
              radius
              color="dark"
              type="border"
              size="small"
              icon="print"
              v-print="printObj"
            ></vs-button>
          </vs-row>
        </div>
      </div>

      <div class="vx-row mb-6">
        <div class="vx-col sm:w-1/5 w-full">
          <span>Submitted</span>
        </div>
        <div class="vx-col sm:w-2/5 w-full">
          <span
            >{{ listSession.submittedAction.timestamp | formatDate }} by
            {{ listSession.submittedAction.userDisplayName }}</span
          >
        </div>
      </div>

      <div class="vx-row mb-6">
        <div class="vx-col sm:w-1/5 w-full">
          <span>Venue </span>
        </div>
        <div class="vx-col sm:w-2/5 w-full">
          <code>{{ listSession.venueName }}</code
          ><span v-if="listSession.list.type === 'CompetitorVisit'">
            (Not REKOM)</span
          >
        </div>
      </div>

      <div class="vx-row mb-6">
        <div class="vx-col sm:w-1/5 w-full">
          <span>Score </span>
        </div>
        <div class="vx-col sm:w-2/5 w-full">
          <div class="flex justify-start">
            <vs-chip
              :color="
                scoreToColor(listSession.metric.overallScore.avgScoreScale)
              "
              >{{ listSession.metric.overallScore.avgScoreScale }}
            </vs-chip>
          </div>
        </div>
      </div>
    </vx-card>

    <!-- List questions start -->
    <vx-card
      class="mb-5"
      v-for="(questionArea, aIdx) in areasWithQuestions"
      :key="aIdx"
      :title="
        isVenueArea(questionArea.area)
          ? questionArea.areaSession
          : noneVenueAreaName
      "
    >
      <p v-if="isVenueArea(questionArea.area)" class="mb-2 text-dark-grey">
        From venue area
        <code
          ><feather-icon
            icon="HomeIcon"
            svgClasses="h-5 w-5"
            class="align-middle"
          />
          {{ questionArea.area.toLowerCase() }}</code
        >.
      </p>
      <!-- start -->
      <div class="px-3 mt-4">
        <!-- max-w-md -->

        <list-question-answer-card
          v-for="(question, qIdx) in questionArea.questions"
          :question="question"
          :key="qIdx"
        />

        <!-- Add new end -->
      </div>
      <!-- end -->
    </vx-card>
    <!-- List questions end -->
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import ListQuestionAnswerCard from "./ListQuestionAnswerCard.vue";

export default {
  components: { ListQuestionAnswerCard },

  data() {
    return {
      type: "",
      hasLoadedData: false,
      noneVenueAreaName: "All areas",
    };
  },
  methods: {},
  computed: {
    scoreToColor() {
      return (score) => {
        return this.$store.getters["lists/scoreColor"](score, this.type);
      };
    },
    ...mapGetters({
      activeVenue: "venues/activeVenue",
      listSession: "lists/listSession",
      iconMap: "lists/iconMap",
    }),
    printObj() {
      let stylesHtml = "";
      for (const node of [
        ...document.querySelectorAll('link[rel="stylesheet"], style'),
      ]) {
        stylesHtml += node.outerHTML;
      }

      return {
        id: "printMe",
        previewTitle: "Print preview",
        popTitle: `List submission - ${this.listSession.list.title} - ${this.listSession.venueName}`,
        extraCss:
          "https://unpkg.com/tailwindcss@^1.0/dist/tailwind.min.css, https://cdn.jsdelivr.net/npm/vuesax/dist/vuesax.css",
        // extraHead: stylesHtml,
      };
    },
    areasWithQuestions() {
      return this.listSession.list.questionAreas.filter(
        (area) => area.questions.length > 0
      );
    },
    containsArea() {
      return (area) => {
        return this.list.questionAreas.some(
          (questionArea) => questionArea.area === area
        );
      };
    },
    isVenueArea() {
      return (name) => name !== "None";
    },
  },
  async mounted() {
    this.type = this.$route.params.type;
    const id = this.$route.params.id;

    await this.$store.dispatch("lists/getListSession", id);
    console.log("Got list session", this.listSession);
    this.hasLoadedData = true;
  },
};
</script>
